/**
 * Scroll behavior after route change
 * @param {Object} to vue-router to object
 * @param {Object} from vue-router from object
 * @param {Object} savedPosition vue-router saved scroll position
 */
export default function (to, from, savedPosition) {
  // Return to saved position if using browser back/forward buttons
  if (savedPosition) {
    return savedPosition
  // Scroll to anchor if route has a hash
  } else if (to.hash) {
    return { selector: to.hash }
  // Default to top left
  } else {
    return { x: 0, y: 0 }
  }
}
